module.exports = __webpack_public_path__ + "assets/img/eternia-31.05365907.jpg";